import {axiosInstance} from '@/services/axiosInstance'

export const EmissorDeCartao = {
  getLista: (parametros) => {
    return axiosInstance.get('v1/cardissuer', {params: parametros})
  },
  getByCardType: (parametros) => {
    return axiosInstance.get('v1/cardissuer/ByPaymentMethod', {params: parametros})
  }
}